import { render, staticRenderFns } from "./PhoneBookList.vue?vue&type=template&id=4b4d4a5c&"
import script from "./PhoneBookList.vue?vue&type=script&lang=js&"
export * from "./PhoneBookList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports